<template>
  <div class="rt-bgView">
    <div class="rt-book_left">
      <img :src="cover_goods" class="rt-book_img"/>
    </div>
    <div class="rt-book_right">
      <p class="rt-book_name">{{btitle}}</p>
      <p class="rt-book_summary">{{second_btitle}}</p>
      <div class="rt-book_p">
        <span class="rt-book_price">{{current_price}}</span>
        <del v-if="original_price > 0" class="rt-book_price_original">{{original_price}}</del>
      </div>
      <div class="rt-book_buy_div">
        <div class="rt-book_buy" @click="buyBook(buy_url)">
          <span class="rt-book_buy-text">去买书</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'rt-book',
    props: {
      b_id: String,
      btitle: String,
      second_btitle: String,
      author: String,
      introduction: String,
      cover_goods: String,
      current_price: String,
      original_price: String,
      buy_url: String,
      published_date: String,
      sequence: String,
      house: String
    },
    methods: {
      buyBook: function (url) {
        window.open(url)
      }
    }
  }
</script>

<style scoped>

  .rt-bgView{
    background-color: #ffffff;
    text-align: left;
    margin-left: 10px;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
  }

  .rt-book_left{
    flex: 1;
    -webkit-flex:1;

  }
  .rt-book_right{
    flex: 3;
    -webkit-flex:3;
    text-align: right;margin:0 auto;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }

  .rt-book_img{
    margin: 10px;
    width: 102px;
    height: 133px;
  }

  .rt-book_name{
    color: #000000;
    font-size: 1.2em;
    text-align: left;
    overflow:hidden;
    text-overflow: ellipsis;
    flex-wrap: nowrap;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 显示三行，后面省略 */
    margin-top: 12px;
  }

  .rt-book_summary{
    color: #b5b5b5;
    font-size: 0.9em;
    text-align: left;
    overflow:hidden;
    text-overflow:ellipsis;
    margin: 0px;
    flex-wrap: nowrap;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 显示三行，后面省略 */
  }

  .rt-book_p{
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    margin-top: 5px;
  }

  .rt-book_price{
    color: red;
    font-size: 1.0em;
    margin-top: 10px;
  }

  .rt-book_price_original{
    color: #b5b5b5;
    font-size: 0.6em;
    margin-left: 5px;
    margin-top: 3px;
    height: 20px;
  }

  .rt-book_buy{
    color: #ffffff;
    font-size: 0.6em;
    margin-right: 10px;
    margin-bottom: 10px;
    background-image: url("../assets/buy_book.png");
    width: 78px;
    height: 28px;
    background-size: 100% 100%;
    cursor: pointer;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
  }
  .rt-book_buy_div{
    align-self: flex-end;
  }

  .rt-book_buy-text{
    align-self: center;
    text-align: center;
    flex: 1;
    -webkit-flex: 1;
    font-size: 1.1em;
  }

</style>



// WEBPACK FOOTER //
// src/components/RtBook.vue